import { SvgAsset, type TSvgAssetProps } from '../../components/svgAsset/SvgAsset';

const InvoiceType = (props: TSvgAssetProps) => (
  <SvgAsset width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M4.58333 7.08301L7.5 9.99967L4.58333 12.9163L1.66666 9.99967L4.58333 7.08301Z"
      stroke="#335DA3"
      strokeWidth="1.04167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 1.66699L12.9167 4.58366L10 7.50033L7.08334 4.58366L10 1.66699Z" stroke="#335DA3" strokeWidth="1.04167" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M15.4167 7.08301L18.3333 9.99967L15.4167 12.9163L12.5 9.99967L15.4167 7.08301Z"
      stroke="#335DA3"
      strokeWidth="1.04167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 12.5L12.9167 15.4167L10 18.3333L7.08334 15.4167L10 12.5Z" stroke="#335DA3" strokeWidth="1.04167" strokeLinecap="round" strokeLinejoin="round" />
  </SvgAsset>
);

export default InvoiceType;
